import React, { useState } from 'react';
import classNames from 'classnames';
import MainRowItem from '../main-row-item';
import PlanRowItem from '../plan-row-item';
const PaywallRowItem = ({
  title,
  tooltip = null,
  disabled = false,
  loading = false,
  availabilities,
  highlightedElementId = '',
  highlighted = false,
  onTooltipHover = Function.prototype,
}) => {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  const classes = classNames('ws-ui-paywall-row-item', {
    'ws-ui-paywall-row-item--highlighted': highlighted,
  });
  const cellClasses = classNames('ws-ui-paywall-row-item__cell', {
    'ws-ui-paywall-row-item__cell--hovered': hover,
  });

  return (
    <div className={classes} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
      <div className={cellClasses}>
        <MainRowItem
          title={title}
          tooltip={tooltip}
          disabled={disabled}
          loading={loading}
          // @ts-ignore TS(2322): Type '{ title: any; tooltip: any; disabled: any; l... Remove this comment to see the full error message
          hover={hover}
          onTooltipHover={onTooltipHover}
        />
      </div>
      {availabilities.map(({ id, contentType, ...rest }) => (
        <div
          className={classNames(cellClasses, {
            'ws-ui-paywall-row-item__cell--highlighted': highlightedElementId === id,
          })}
          key={id}
        >
          <PlanRowItem
            loading={loading}
            // @ts-ignore TS(2322): Type '{ loading: boolean; hover: boolean; co... Remove this comment to see the full error message
            hover={hover}
            contentType={disabled ? 'icon-minus' : contentType}
            {...rest}
          />
        </div>
      ))}
      {highlighted && (
        <React.Fragment>
          <span className="ws-ui-paywall-row-item__highlight-comet ws-ui-paywall-row-item__highlight-comet--first" />
          <span className="ws-ui-paywall-row-item__highlight-comet ws-ui-paywall-row-item__highlight-comet--second" />
        </React.Fragment>
      )}
    </div>
  );
};

export default PaywallRowItem;
